import { render, staticRenderFns } from "./IndividualContact2.vue?vue&type=template&id=18a9a16c&scoped=true&"
import script from "./IndividualContact2.vue?vue&type=script&lang=js&"
export * from "./IndividualContact2.vue?vue&type=script&lang=js&"
import style0 from "./IndividualContact2.vue?vue&type=style&index=0&id=18a9a16c&scoped=true&lang=css&"
import style1 from "./IndividualContact2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a9a16c",
  null
  
)

export default component.exports